// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac1ea9e6","453":"e90b6513","732":"f9a64c03","977":"3e3b3f2d"}[chunkId] + ".chunk.js";
};